import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../../Helpers/LoadingSpinner';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Mensaje from '../../Models/Mensaje';
import DowngradeAviso from '../../Components/Features/UpSelling/DowngradeAviso';
import { CambioPlanCodigo } from '../../Models/CambioPlanCodigo';
import Deuda from '../../Components/Common/Banners/Deuda';
import CallCenter from '../../Components/Features/UpSelling/CallCenter';
import SinSuscripcionDigital from '../../Components/Features/UpSelling/SinSuscripcionDigital';
import { trackPage } from '../../Helpers/UpsellingTracker';
import Toast from '../../Components/Common/Modules/Toast';
import '../../Statics/Scss/Pages/UpsellingConfirmar.scss';
import useGetInfoPlanUpselling from '../../Hooks/useGetInfoPlanUpselling';
import Planes from '../../Components/Features/UpSelling/Planes';
import useConfirmarCambioUpselling from '../../Hooks/useConfirmarCambioUpselling';
import Breadcrumb from '../../Components/Common/Modules/Breadcrumb';
import TitleWeb from '../../Components/Common/Web/Title';
import { getUpsellingNombresAmigables } from '../../Config/UpsellingNombresAmigables';
import UrlProperties from '../../Helpers/UrlProperties';
import PathsConfig from '../../Config/RoutePaths';
import useGetCampaniasUpselling from '../../Hooks/useGetCampaniasUpselling';
import useRedirectWithout from '../../Hooks/useRedirectWithout';

const UpsellingConfirmar = () => {
    const history = useHistory();
    const stepProps = ["tieneClub"];
    const { pathname, state } = useLocation();
    const stateParse = state ?? { tieneClub: true}
    const { tieneClub, planActual } = useRedirectWithout(stateParse, stepProps, PathsConfig.MisSuscripciones);
    const [infoUpselling, errorInfoUpselling, loadingInfoUpselling, getInfoUpselling] = useGetInfoPlanUpselling();
    const [errorConfirmarUpselling, loadingConfirmarUpselling, confirmarUpselling] = useConfirmarCambioUpselling();
    const [campaniasUpselling, errorCampaniasUpselling , loadingCampaniasUpselling] = useGetCampaniasUpselling();
    const { plan } = useParams();
    const pathUpselling = pathname.split('confirmar-upselling')[1];
    const [planUp, setPlanUp] = useState();
    const [campaniaEncontrada, setCampaniaUp] = useState();

    useEffect(() => {
        if(campaniasUpselling !== null){
            let planEncontrado = null;
            let campaniaEncontrada = null;

            campaniasUpselling.some(campania => {
                const foundPlan = campania.planes.find(singlePlan => singlePlan.key.includes(plan));
                if (foundPlan) {
                    planEncontrado = foundPlan;
                    campaniaEncontrada = campania;
                    return true;  // Termina el bucle al encontrar el elemento
                }
                return false;  // Continúa buscando en la siguiente iteración
            });

            if (!planEncontrado) {
                history.push({ pathname: PathsConfig.MisSuscripciones });
            } else {
                setPlanUp(planEncontrado);
                setCampaniaUp(campaniaEncontrada);
                getInfoUpselling({ campania: campaniaEncontrada.id, planUpselling: planEncontrado, pathUpselling, planActual });
            }
        }
    }, [campaniasUpselling]);

    const handleRouteToADClub = ()=> {
        history.push({
            pathname: `${PathsConfig.UpsellingConfirmar}/${plan}/domicilio`,
            state:{
                IdCanalDeVenta: UrlProperties.getParamOrSetIfNotExist('cv', campaniaEncontrada.canalVentaDefault),
                IdCampaniaUpsell: infoUpselling.IdCampaniaUpsell,
                IdFormaDeContacto: UrlProperties.getParamOrSetIfNotExist('fc', campaniaEncontrada.formaContactoDefault)
            }
        })
    }
    
    const handleClickConfirmacionUpsell = (data)=>{ 
            confirmarUpselling(campaniaEncontrada.id, 
                planUp.id, 
                data.NombreUpsell, 
                pathUpselling, 
                infoUpselling, 
                UrlProperties.getParamOrSetIfNotExist('cv', campaniaEncontrada.canalVentaDefault), 
                UrlProperties.getParamOrSetIfNotExist('fc', campaniaEncontrada.formaContactoDefault),
                tieneClub,
                handleRouteToADClub,
                infoUpselling.IdSuscripcionActual,
                planActual
                )
    }

    const PageState = (data) => {
        if (data == null || !data || data.Codigo == null) return null;
        let result = null;
        switch (data.Codigo) {
            case CambioPlanCodigo.ERROR_DATOS:
                result = <Toast status="warning" closeAuto={3000} title={Mensaje.getError('GENERAL')} />;
                break;
            case CambioPlanCodigo.OK:
                result = (
                    <Planes
                        NombreActual={data.NombreActual}
                        NombreUpsell={data.NombreUpsell}
                        CantidadCredencialesActual={data.CantidadCredencialesActual}
                        CredencialesPlanUpsell={data.CredencialesPlanUpsell}
                        PrecioActual={data.PrecioActual}
                        PrecioUpsell={data.PrecioUpsell}
                        Tarjeta={data.Tarjeta}
                        CredencialCategoria={data.CredencialCategoria}
                        PlanDeVenta={data.PlanDeVenta}
                        TieneClub={tieneClub}
                        ConfirmarPlan={()=> handleClickConfirmacionUpsell(data)}
                        hasError={errorInfoUpselling || errorConfirmarUpselling || errorCampaniasUpselling}
                    />
                );
                break;
            case CambioPlanCodigo.USUARIO_INVALIDO:
                trackPage('upselling_usuario_no_valido', pathUpselling, data);
                result = <SinSuscripcionDigital />;
                break;
            case CambioPlanCodigo.DEUDA:
                result = <Deuda />;
                break;
            case CambioPlanCodigo.CALL_CENTER:
                result = <CallCenter />;
                break;
            case CambioPlanCodigo.DOWNSALE:
                result = <DowngradeAviso nombreActual={data.NombreActual} />;
                break;
        }
        return result;
    };

    return (
        <div className='container-fluid-streched'>
            <LoadingSpinner isLoading={loadingInfoUpselling || loadingConfirmarUpselling || loadingCampaniasUpselling}>
                <section>
                    <Breadcrumb
                        firstItem="Mis suscripciones"
                        secondItem={`Cambiando a ${getUpsellingNombresAmigables[plan]}`}
                        text="Ver suscripciones"
                        href="#"
                    />
                    <TitleWeb text={`Cambiando a ${getUpsellingNombresAmigables[plan]}`} />
                </section>
                {(errorInfoUpselling || errorConfirmarUpselling || errorCampaniasUpselling) && <Toast status="warning" title={errorInfoUpselling || errorConfirmarUpselling || errorCampaniasUpselling} />}
                {infoUpselling && PageState(infoUpselling)}
            </LoadingSpinner>
        </div>
    );
};

export default UpsellingConfirmar;
